export const PAYMENT_TYPE_PAYMENT = 'payment' // vollständig vezahlt
export const PAYMENT_TYPE_MORE_CREDIT = 'credit' // als Kundenguthaben verbuchen
export const PAYMENT_TYPE_MORE_SURCHARGE = 'surcharge' // Zuschlag
export const PAYMENT_TYPE_MORE_SETTLE = 'settle' // mit anderen Rechnungen verrechnen
export const PAYMENT_TYPE_MORE_BOOK_LATER = 'bookLater' // später verbuchen
export const PAYMENT_TYPE_LESS_PARTIAL = 'partial' // Teilzahlung
export const PAYMENT_TYPE_LESS_DISCOUNT = 'discount' // Skonto
export const PAYMENT_TYPE_LESS_BANKCHARGE = 'bankcharge' // Bankgebühr
export const DEVIATION_KIND_SURPLUS = 'surplus'
export const DEVIATION_KIND_DEFICIT = 'deficit'

export default {
  PAYMENT_TYPE_PAYMENT,
  PAYMENT_TYPE_MORE_CREDIT,
  PAYMENT_TYPE_MORE_SURCHARGE,
  PAYMENT_TYPE_MORE_SETTLE,
  PAYMENT_TYPE_MORE_BOOK_LATER,
  PAYMENT_TYPE_LESS_PARTIAL,
  PAYMENT_TYPE_LESS_DISCOUNT,
  PAYMENT_TYPE_LESS_BANKCHARGE,
  DEVIATION_KIND_SURPLUS,
  DEVIATION_KIND_DEFICIT,
}
